import request from "../utils/request";

export const getCaptcha = () => {
    return request.get("/captcha");
}

// 登录接口
export const doLogin = (data) => {
    return request.post("/login", data);
}

// 登出/退出登录接口
export const doLoginOut = (data) => {
    return request.post("/loginOut", data);
}

export const doGetCurrUserInfo = () => {
    return request.get("/userInfo");
}